export { default } from './TrayWidget'



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/TrayWidget/index.js